import { render, staticRenderFns } from "./SidemenuInformationPanel.vue?vue&type=template&id=59dc62a5&scoped=true&lang=pug&"
import script from "./SidemenuInformationPanel.vue?vue&type=script&lang=ts&"
export * from "./SidemenuInformationPanel.vue?vue&type=script&lang=ts&"
import style0 from "./SidemenuInformationPanel.vue?vue&type=style&index=0&id=59dc62a5&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dc62a5",
  null
  
)

export default component.exports